export const DS_BREAKPOINTS = {
  mobile: 480,
  tablet: 834,
  desktop: 1024,
} as const;

export const DS_TOKENS = {
  modal: {
    backdrop: {
      bgColor: '#000000',
      opacity: '0.8',
    },
  },
  media: {
    mobile: `@media (max-width: ${DS_BREAKPOINTS.tablet - 1}px)`,
    tablet: `@media (min-width: ${DS_BREAKPOINTS.tablet}px) and (max-width: ${
      DS_BREAKPOINTS.desktop - 1
    }px)`,
    desktop: `@media (min-width: ${DS_BREAKPOINTS.desktop}px)`,
    up(bp: keyof typeof DS_BREAKPOINTS) {
      return `@media (min-width: ${DS_BREAKPOINTS[bp]}px)`;
    },

    down(bp: keyof typeof DS_BREAKPOINTS) {
      return `@media (max-width: ${DS_BREAKPOINTS[bp] - 1}px)`;
    },

    between(
      min: keyof typeof DS_BREAKPOINTS,
      max: keyof typeof DS_BREAKPOINTS
    ) {
      return `@media (min-width: ${DS_BREAKPOINTS[min]}px) and (max-width: ${
        DS_BREAKPOINTS[max] - 1
      }px)`;
    },
  },
  animation: {
    duration: {
      instant: '50ms',
      short: '150ms',
      base: '200ms',
      medium: '300ms',
      long: '400ms',
      slow: '600ms',
    },
    easing: {
      standard: 'ease-in-out',
      accelerate: 'cubic-bezier(0.4, 0, 1, 1)',
      decelerate: 'cubic-bezier(0, 0, 0.2, 1)',
      elastic: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
      easeInOut: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
    },
  },
} as const;
